export const paginate = <T extends {}[] = {}[]>(data: T, page: number, limit: number) => {
    return [...data].slice((page - 1) * limit, page * limit);
};
